// Official Bulbapedia rarities with abbreviations
// https://bulbapedia.bulbagarden.net/wiki/Rarity
export const RARITIES = [
  { abbr: 'C',   name: 'Common' },
  { abbr: 'U',   name: 'Uncommon' },
  { abbr: 'H',   name: 'Holofoil Rare' },
  { abbr: 'SH',  name: 'Shiny Rare' },
  { abbr: 'RR',  name: 'Double Rare' },
  { abbr: 'UR',  name: 'Ultra Rare' },
  { abbr: 'SR',  name: 'Secret Rare' },
  { abbr: 'ACE', name: 'ACE SPEC Rare' },
  { abbr: 'AR',  name: 'Illustration Rare' },
  { abbr: 'SAR', name: 'Special Illustration Rare' },
  { abbr: 'MAR', name: 'Mega Attack Rare' },
  { abbr: 'HR',  name: 'Hyper Rare' },
  { abbr: 'MHR', name: 'Mega Hyper Rare' },
];

// Map abbreviation → full name for quick lookups
export const RARITY_MAP = Object.fromEntries(
  RARITIES.map((r) => [r.abbr, r.name])
);

// List of abbreviations for backward compatibility
export const RARITY_OPTIONS = RARITIES.map((r) => r.abbr);

export const SOURCE_OPTIONS = [
  { value: 'ebay', label: 'eBay' },
  { value: 'vinted', label: 'Vinted' },
  { value: 'cardmarket', label: 'CardMarket' },
];

export const LANGUAGE_OPTIONS = [
  { value: 'FR', label: 'French' },
  { value: 'EN', label: 'English' },
  { value: 'JA', label: 'Japanese' },
  { value: 'Other', label: 'Other' },
];

export const SORT_FIELDS = [
  { value: 'scraped_at', label: 'Date Added' },
  { value: 'listing_date', label: 'Listing Date' },
  { value: 'card_name', label: 'Name' },
  { value: 'price', label: 'Price' },
  { value: 'cardmarket_price', label: 'CardMarket Price' },
  { value: 'tcgplayer_price', label: 'TCGplayer Price' },
  { value: 'rarity', label: 'Rarity' },
  { value: 'language', label: 'Language' },
  { value: 'extension', label: 'Extension' },
  { value: 'source', label: 'Source' },
];

export const PER_PAGE = 50;
